module.exports = __webpack_public_path__ + "static/img/awardwinner_btn_eng.68f9d1a4.png";